export enum AnalyticsEvent {
    SearchedHotel = 'Searched Hotel',
    ViewedHotelResults = 'Viewed Hotel Results',
    ClickedHotelResult = 'Clicked Hotel Result',
    ViewedHotelDetails = 'Viewed Hotel Details',
    ClickedReserveRoom = 'Clicked Reserve Room',
    VisitedHotelCheckout = 'Visited Hotel Checkout',
    CreatedHotelCheckoutAccount = 'Created Hotel Checkout Account',
    CompletedCheckoutUpgrade = 'Completed Checkout Upgrade',
    OpenedHotelPayment = 'Opened Hotel Payment',
    BookedHotel = 'Booked Hotel',
    HotelBookingFailed = 'Hotel Booking Failed',
    ViewedTrips = 'Viewed Trips',
    ViewedTripDetails = 'Viewed Trip Details',
    CancelledHotelBooking = 'Cancelled Hotel Booking',
    ViewedRewards = 'Viewed Rewards',
    ClickedRedeemReward = 'Clicked Redeem Reward',
    ClickedUpgradeCta = 'Clicked Upgrade CTA',
    StartedCheckoutUpgrade = 'Started Checkout Upgrade',
}

export enum UpgradeSource {
    DashboardMenuBar = 'dashboard_menu_bar',
    HotelsLanding = 'hotels_landing',
    HotelDetail = 'hotel_detail',
    HotelCheckout = 'hotel_checkout',
    RewardsLocked = 'rewards_locked',
    TripDetailPointsBanner = 'trip_detail_points_banner',
}

export enum NavSurface {
    DesktopNav = 'desktop_nav',
    MobileTabBar = 'mobile_tab_bar',
}

export enum UserTier {
    Guest = 'guest',
}

export enum UserState {
    Anonymous = 'anonymous',
    Free = 'free',
    Paid = 'paid',
}

export enum HotelResultSource {
    List = 'list',
    Map = 'map',
}

export enum DestinationKind {
    City = 'city',
    Hotel = 'hotel',
    Nearby = 'nearby',
}

export enum RoomRateType {
    Standard = 'standard',
    Member = 'member',
}

export enum BookingPaymentMethod {
    Card = 'card',
    Points = 'points',
    PointsAndCard = 'points_and_card',
}

export enum BookingFailureStage {
    Payment = 'payment',
    Finalize = 'finalize',
    Redemption = 'redemption',
}
